// Global Instructions Rule Applied!
//
// Configuration → Contact Relationships admin models: the types → titles
// hierarchy over cfg.contact_relationship_types / cfg.contact_relationship_titles.
// A type row carries titles_count + usage_count (junction references via its
// titles); a title row carries per-junction (accounts / deals / prospects)
// and total usage counts — what the delete guard checks (usage > 0 forces the
// Replace flow). Shapes mirror public.view__contact_relationship_types /
// public.view__contact_relationship_titles.
import { z } from 'zod'
import { validateWithZodSchema } from '../../core/utils/utilities.ts'

export const ContactRelationshipTypeAdminRowSchema = z
  .object({
    contact_relationship_types__id: z.string(),
    contact_relationship_types__name: z.string(),
    contact_relationship_types__gets_comms: z.boolean(),
    contact_relationship_types__track_interactions: z.boolean(),
    contact_relationship_types__sort_order: z.number().nullish(),
    contact_relationship_types__titles_count: z.number(),
    contact_relationship_types__usage_count: z.number(),
    contact_relationship_types__date_modified: z.string().nullish()
  })
  .strict()

export type ContactRelationshipTypeAdminRow = z.infer<typeof ContactRelationshipTypeAdminRowSchema>

export const ContactRelationshipTitleAdminRowSchema = z
  .object({
    contact_relationship_titles__id: z.string(),
    contact_relationship_titles__type_id: z.string(),
    contact_relationship_types__name: z.string(),
    contact_relationship_titles__name: z.string(),
    contact_relationship_titles__sort_order: z.number().nullish(),
    contact_relationship_titles__accounts_count: z.number(),
    contact_relationship_titles__deals_count: z.number(),
    contact_relationship_titles__prospects_count: z.number(),
    contact_relationship_titles__usage_count: z.number(),
    contact_relationship_titles__date_modified: z.string().nullish()
  })
  .strict()

export type ContactRelationshipTitleAdminRow = z.infer<typeof ContactRelationshipTitleAdminRowSchema>

export function validateContactRelationshipTypeAdminRow(
  data: unknown,
  options?: { isArray?: boolean }
): ContactRelationshipTypeAdminRow | ContactRelationshipTypeAdminRow[] {
  try {
    return validateWithZodSchema(
      ContactRelationshipTypeAdminRowSchema,
      data,
      'contact relationship type admin row',
      options
    ) as ContactRelationshipTypeAdminRow | ContactRelationshipTypeAdminRow[]
  } catch (e) {
    throw new Error(`Contact relationship type validation failed: ${e}`)
  }
}

export function validateContactRelationshipTitleAdminRow(
  data: unknown,
  options?: { isArray?: boolean }
): ContactRelationshipTitleAdminRow | ContactRelationshipTitleAdminRow[] {
  try {
    return validateWithZodSchema(
      ContactRelationshipTitleAdminRowSchema,
      data,
      'contact relationship title admin row',
      options
    ) as ContactRelationshipTitleAdminRow | ContactRelationshipTitleAdminRow[]
  } catch (e) {
    throw new Error(`Contact relationship title validation failed: ${e}`)
  }
}
